import { memo } from "react"
import Advertisement from "./advertisement-sidebar/Advertisement"
import AuthorsSidebar from "./authors-sidebar/AuthorsSidebar"
import '../assets/css/Sidebar.css'

const Sidebar = memo(function Sidebar() {

    return (
        <div className="flex-container flex-column sidebar top-margin-5">
            <AuthorsSidebar />
            <Advertisement />
        </div>
    )
})

export default Sidebar